import styled from 'styled-components';
import { CssRule } from '../../../../themes/architecture/css-helpers/css-rule';

const DefaultBox = styled.div`
    height: 40px;
    margin-top: 40px;
    
    ${CssRule.For.mobile.landscape.build()} & {
        margin-top: 5px;
    }
`;

export const PartyJackpotWinCelebrationPopupButtonsContainerBox = DefaultBox;